// extracted by mini-css-extract-plugin
export default {"container":"author-summary_container__3oGhh","image":"author-summary_image__n2yaB","picture":"author-summary_picture__XLj5b","subscription":"author-summary_subscription__15JVQ"};